import logo1 from "../Images/logo1.jpg";
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';


function Navi() {
    return (
        <>
            <div className="a9">
                <a href="tel:8667641134" className="a10"><i className="bi bi-telephone-fill"></i> 8667641134</a>
            </div>
            <Navbar collapseOnSelect expand="lg" className="a8 bg-body-tertiary">
                <Container fluid>
                    <Navbar.Brand href="/"><img src={logo1} className="a7 mx-3" /></Navbar.Brand>
                    <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                    <Navbar.Collapse id="responsive-navbar-nav">
                        <Nav className="ms-auto nav-links">
                            <Nav.Link href="/" className="custom-link">Home</Nav.Link>
                            <Nav.Link href="/#courses" className="custom-link">Courses</Nav.Link>
                            <Nav.Link href="/#contact" className="custom-link">Contact</Nav.Link>
                            <Nav.Link href="/#FAQ" className="custom-link"> FAQ </Nav.Link>

                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </>
    );
}

export default Navi;